import { ActionTree, GetterTree, MutationTree } from 'vuex'

export interface State {
    langId: string
    lang: string
    link: string
    enableRanking: boolean
    rankingLimit: string
    userRoleId: string
    userRoleName: string
    customField: string
    countUsersForUserRole: number
}

const INITIAL_STATE: State = {
    langId: '',
    lang: '',
    link: '',
    enableRanking: true,
    rankingLimit: '',
    userRoleId: '',
    userRoleName: '',
    customField: '',
    countUsersForUserRole: 0,
}

const actions: ActionTree<State, any> = {
    setLangId({ commit }, langId: string) {
        commit('setLangId', langId)
    },
    setLang({ commit }, lang: string) {
        commit('setLang', lang)
    },
    setLink({ commit }, link: string) {
        commit('setLink', link)
    },
    setRankingConfiguration({ commit }, configuration) {
        commit('setRankingConfiguration', configuration)
    },
    setUserRole({ commit }, userRole) {
        commit('setUserRole', userRole)
    },
    setCustomField({ commit }, customField) {
        commit('setCustomField', customField)
    },
    setCountUsersForUserRole({ commit }, countUsersForUserRole) {
        commit('setCountUsersForUserRole', countUsersForUserRole)
    },
    resetConfiguration({ commit }) {
        commit('resetConfiguration')
    },
}

const mutations: MutationTree<State> = {
    setLangId(state, langId: string) {
        state.langId = langId
    },
    setLang(state, lang: string) {
        state.lang = lang
    },
    setLink(state, link: string) {
        state.link = link
    },
    setRankingConfiguration(state, configuration) {
        state.enableRanking = configuration.enableRanking
        state.rankingLimit = configuration.rankingLimit
    },
    setUserRole(state, { id, name }: { id: string; name: string }) {
        state.userRoleId = id
        state.userRoleName = name
    },
    setCustomField(state, customField: string) {
        state.customField = customField
    },
    setCountUsersForUserRole(state, countUsersForUserRole: number) {
        state.countUsersForUserRole = countUsersForUserRole
    },
    resetConfiguration(state) {
        const initial = INITIAL_STATE
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

const getters: GetterTree<State, any> = {
    langId: ({ langId }) => langId,
    lang: ({ lang }) => lang,
    link: ({ link }) => link,
    enableRanking: ({ enableRanking }) => enableRanking,
    rankingLimit: ({ rankingLimit }) => rankingLimit,
    userRole: ({ userRoleId, userRoleName }) => ({
        id: userRoleId,
        name: userRoleName,
    }),
    userRoleId: ({ userRoleId }) => userRoleId,
    configuration: (state) => state,
    customField: ({ customField }) => customField,
    countUsersForUserRole: ({ countUsersForUserRole }) => countUsersForUserRole,
}

export default {
    namespaced: true,
    state: INITIAL_STATE,
    getters,
    mutations,
    actions,
}
